import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { NewMessagesBadge } from '../NewMessagesBadge/NewMessagesBadge';
import { useUnreadBadgePresenter } from './UnreadBadge.presenter';

interface IUnreadBadgeProps {
  className?: string;
}

export const UnreadBadge: FC<IUnreadBadgeProps> = observer(({ className }) => {
  const presenter = useUnreadBadgePresenter();

  if (presenter.hasNewMessages) {
    return <NewMessagesBadge className={className} />;
  }

  return null;
});
